module.exports = __webpack_public_path__ + "static/media/left@2x.4ae11974.svg";